require('./contractEasyLoanStep1Waffer.scss');

const PropTypes = require('prop-types');

//@vendor
const React = require('react');
const classnames = require('classnames');
// @core
const { FormattedText } = require('core/i18n').i18n;
// @components
const ContractEasyLoanStepOneTooltip = require('../contractEasyLoanStepOneTooltip/contractEasyLoanStepOneTooltip');
//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

//@utilities
const { formatInterest, decimalsLength, getFormattedString, hasDecimals } = require('utilities/currencyHelper');
//@constants
const { EURO_TEXT } = require('constants/index');

class ContractEasyLoanStepOneWaffer extends React.Component {
    buildOpeningCommission() {
        const { immContractEasyLoan } = this.props;

        const immOpeningCommission = immContractEasyLoan.get('openingCommission');
        const openingCommissionAmount = immOpeningCommission.get('amount');
        const showBothCommissions = immOpeningCommission.get('showPercentajeCommission') && immOpeningCommission.get('showMinCommission');
        const decimalLength = decimalsLength(openingCommissionAmount);

        const rawOpeningCommissionPercentaje = immOpeningCommission.get('percentage');
        const openingCommissionPercentaje = formatInterest(rawOpeningCommissionPercentaje);

        let openingCommissionMinElement;
        let labelTransKey;
        let injectedStrings;

        const labelStyles = classnames('contract-easy-loan-step-one-waffer__element-label', {
            'contract-easy-loan-step-one-waffer__element-label--has-second-line': showBothCommissions
        });

        const openingCommissionAmountText = getFormattedString({
            amount: openingCommissionAmount,
            decimalsLength: decimalLength,
            currency: immContractEasyLoan.get('currency')
        });

        const openingCommissionAmountMin = immOpeningCommission.get('minimum');

        if (showBothCommissions) {
            labelTransKey = 'openingCommissionWithPercentaje';
            injectedStrings = [openingCommissionPercentaje];

            const decimalsLengthMin = hasDecimals(openingCommissionAmountMin) ? 0 : 2;

            const openingCommissionMin = getFormattedString({
                amount: immOpeningCommission.get('minimum'),
                decimalsLength: decimalsLengthMin,
                currency: EURO_TEXT
            });

            openingCommissionMinElement = (
                <div className="contract-easy-loan-step-one-waffer__element-label contract-easy-loan-step-one-waffer__element-label--minimum">
                    <FormattedText value="contractEasyLoanTooltip-openingCommissionMin" injectedStrings={[openingCommissionMin]} />
                </div>
            );
        } else if (immOpeningCommission.get('showPercentajeCommission')) {
            labelTransKey = 'openingCommissionWithPercentaje';
            injectedStrings = [openingCommissionPercentaje];
        } else {
            labelTransKey = 'openingCommission';
        }

        return (
            <div className="contract-easy-loan-step-one-waffer__element">
                <div className={labelStyles}>
                    <FormattedText value={`contractEasyLoanTooltip-${labelTransKey}`} injectedStrings={injectedStrings} /> 
                    <sup>1</sup>
                </div>
                {openingCommissionMinElement}
                <div className="contract-easy-loan-step-one-waffer__element-value">
                    {openingCommissionAmountText}
                </div>
            </div>
        );
    }

    render() {
        const { immContractEasyLoan } = this.props;
        const openingCommissionElement = this.buildOpeningCommission();
        let content;

        const tin = formatInterest(immContractEasyLoan.get('tin'));
        const tae = formatInterest(immContractEasyLoan.get('tae'));

        const installmentAmount = getFormattedString({
            amount: immContractEasyLoan.getIn(['installment', 'amount']),
            currency: immContractEasyLoan.getIn(['installment', 'currency'])
        });

        const taeTooltipContent = (
            <ContractEasyLoanStepOneTooltip
                immContractEasyLoan={immContractEasyLoan}
                clarifyingText="clarifyingText"
            />);

        if (immContractEasyLoan.get('isFetchingInstallment') || immContractEasyLoan.get('isFetchingMinInstallmentQuantity')) {
            content = <LoadingSection />;
        } else {
            const { immContractEasyLoan } = this.props;

            const immOpeningCommission = immContractEasyLoan.get('openingCommission');
            const showBothCommissions = immOpeningCommission.get('showPercentajeCommission') && immOpeningCommission.get('showMinCommission');
            const labelStyles = classnames('contract-easy-loan-step-one-waffer__element-label',
                {
                    'contract-easy-loan-step-one-waffer__element-label--second-line': showBothCommissions
                });

            content = (
                <div className="contract-easy-loan-step-one-waffer">
                    <div className="contract-easy-loan-step-one-waffer__section contract-easy-loan-step-one-waffer__section--interest">
                        <div className="contract-easy-loan-step-one-waffer__element contract-easy-loan-step-one-waffer__element--first">
                            <div className={labelStyles}>
                                <FormattedText value="contractEasyLoan-anualTin" />
                            </div>
                            <div className="contract-easy-loan-step-one-waffer__element-value">
                                {tin}
                            </div>
                        </div>
                        <div className="contract-easy-loan-step-one-waffer__element">
                            <div className={labelStyles}>
                                <strong><FormattedText value="contractEasyLoan-TAE" className="contract-easy-loan-step-one-waffer__tin-element" /></strong>
                                <OKTooltip
                                    alternativeIcon={true}
                                    content={taeTooltipContent}
                                    modifier="dark-bg"
                                    offset={[10, 0]}
                                    placement="right"
                                    type="custom"
                                />
                            </div>
                            <div className="contract-easy-loan-step-one-waffer__element-value">
                                {tae}
                            </div>
                        </div>
                        {openingCommissionElement}
                    </div>
                    <div className="contract-easy-loan-step-one-waffer__section contract-easy-loan-step-one-waffer__section--installment">
                        <div className="contract-easy-loan-step-one-waffer__installment">
                            <div className="contract-easy-loan-step-one-waffer__installment-label">
                                <FormattedText value="contractEasyLoan-monthlyInstallment" />
                            </div>
                            <div className="contract-easy-loan-step-one-waffer__installment-amount">
                                {installmentAmount}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return content;
    }
}

ContractEasyLoanStepOneWaffer.propTypes = {
    immContractEasyLoan: PropTypes.object
};

module.exports = ContractEasyLoanStepOneWaffer;
